export const DESKTOP =  'desktop';
export const BROWSER_VALUE = 'Browser';
export const DEFAULT_BROWSER = 'Browser Not Found';
export const DEFAULT_OS = 'OS Not Found';
